import MuiLink from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Link from 'next/link';
import { protocol, rootDomain } from '@/utils';

export default function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {'© '}
      <MuiLink
        component={Link}
        color="inherit"
        href={`${protocol}://${rootDomain}`}
      >
        ethics.life
      </MuiLink>{' '}
      {new Date().getFullYear()}
    </Typography>
  );
}
